import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, css, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, ICONS, LinkUnstyled, unit } from '@hcr/ui'

import { LINK_CONFIG } from '../../../../../../configs'
import { Path } from '../../../../../../models/navigation'

interface NavigationLinksProps {
  isLogged: boolean
  isOwner: boolean
}

export const NavigationLinks: FC<NavigationLinksProps> = ({ isLogged, isOwner }) => {
  const { t } = useTranslation()

  return (
    <Box component='nav'>
      <Box
        component='ul'
        sx={{
          '& .MuiButton-root': {
            '&:hover': {
              backgroundColor: 'inherit',
              boxShadow: 'none',
            },
          },
        }}
      >
        <Link component={LinkUnstyled} to={LINK_CONFIG.webshop}>
          <Typography variant='bodyM'>{t('account.holidayclub.fi')}</Typography>
          <IconBox>
            <Icon aria-hidden='true' icon={ICONS.fasChevronRight} />
          </IconBox>
        </Link>
        <ActiveLink component={LinkUnstyled} to={Path.Home} aria-current='page'>
          <Typography variant='bodyM'>{t('account.omat-lomasivut')}</Typography>
          <IconBox>
            <Icon aria-hidden='true' icon={ICONS.fasChevronRight} />
          </IconBox>
        </ActiveLink>
        <Link component={LinkUnstyled} to={Path.Booking}>
          <Typography variant='labelM' fontWeight={'normal'}>
            {t('booking.your-booking')}
          </Typography>
        </Link>
        {(!isLogged || isOwner) && (
          <>
            <Divider />
            <Link component={LinkUnstyled} to={Path.Owner}>
              <Typography variant='labelM' fontWeight={'normal'}>
                {t('owner.your-holdings')}
              </Typography>
            </Link>
          </>
        )}
        {isLogged && (
          <>
            <Divider />
            <Link component={LinkUnstyled} to={Path.Account}>
              <Typography variant='labelM' fontWeight={'normal'}>
                {t('account.personal-information')}
              </Typography>
            </Link>
          </>
        )}
      </Box>
    </Box>
  )
}

const IconBox = styled(Box)`
  height: ${unit(11)};
  width: ${unit(11)};
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${unit(4)};
  width: ${unit(3.5)};
`

const Icon = styled(FontAwesomeIcon)`
  text-align: center;
  font-size: ${unit(4.5)};
  line-height: ${unit(4)};
`
const linkProps = css`
  display: flex;
  justify-content: space-between;
  padding: ${unit(2)} ${unit(3)} ${unit(2.5)} ${unit(5.5)};
  color: ${COLORS.black};
  height: ${unit(15.25)};

  &:hover {
    color: ${COLORS.red['dark']};
  }
`

const Link = styled(Button)`
  ${linkProps};
` as typeof Button

const ActiveLink = styled(Button)`
  ${linkProps};
  border-left: ${unit(1)} solid ${COLORS.burgundi[500]};
  border-bottom: ${unit(0.25)} solid ${COLORS.vaalea[600]};
  border-top: ${unit(0.25)} solid ${COLORS.vaalea[600]};
` as typeof Button

const Divider = styled(Box)`
  height: 0;
  border-bottom: ${unit(0.25)} solid ${COLORS.vaalea[600]};
  border-bottom-style: dashed;
  margin: 0 ${unit(5)};
`
